import { Component, Input, OnInit } from '@angular/core'
import { take } from 'rxjs/operators'
import { RulesService } from '../services/rules-service/rules.service'

@Component({
  selector: 'hs-rule-code',
  templateUrl: './rule-code.component.html',
  styleUrls: ['./rule-code.component.scss'],
})
export class RuleCodeComponent implements OnInit {
  _ruleIdSelected?: number
  ruleCode = ''
  isRuleCodeLoading = false

  constructor(public rulesService: RulesService) {}

  ngOnInit(): void {
    //
  }

  @Input() set ruleIdSelected(value: number | undefined) {
    if (value && this._ruleIdSelected != value) {
      this.displayRuleCode(value)
    }
  }
  displayRuleCode(ruleId: number) {
    this.isRuleCodeLoading = true
    this.rulesService
      .getRuleCode(ruleId)
      .pipe(take(1))
      .subscribe(ruleCode => {
        this.ruleCode = ruleCode.code
        this.isRuleCodeLoading = false
      })
  }
}
